import React, { useState, useMemo } from 'react';
import { useNews } from '../../hooks/useNews';
import { dashboardStyles as s } from '../../styles/dashboardStyles';
import { newsStyles as ns } from '../../styles/newsStyles';
import { formatDateLabel, formatLocationLabel } from '../../utils/newsHelpers';
import NewsCard from './NewsCard';

const EmptyState = () => (
  <div className={ns.emptyWrapper}>
    <div className={ns.emptyIcon}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" /><path d="M11 8v3l2 2" opacity="0.5" />
      </svg>
    </div>
    <h4 className={ns.emptyTitle}>Sin novedades por el momento</h4>
    <p className="text-slate-300 text-xs mt-2 italic">Vuelve pronto para ver nuevas actualizaciones.</p>
  </div>
);

const News = () => {
  const { news, userCities, loading } = useNews();
  const [isAsc, setIsAsc] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const sortedNews = useMemo(() => {
    return [...news].sort((a, b) => {
      const dateA = new Date(a.starts_at);
      const dateB = new Date(b.starts_at);
      return isAsc ? dateA - dateB : dateB - dateA;
    });
  }, [news, isAsc]);

  const maxPerRow = useMemo(() => {
    const X = news.length;
    return (X % 3 === 0 || X === 5) ? 3 : 4;
  }, [news.length]);

  const displayedNews = isExpanded ? sortedNews : sortedNews.slice(0, maxPerRow);

  const toggleExpand = () => {
    if (isExpanded) {
      const section = document.getElementById('news');
      if (section) {
        const top = section.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
    setIsExpanded(!isExpanded);
  };

  if (loading) return <div className={ns.syncText}>Sincronizando...</div>;
  if (news.length === 0) return <EmptyState />;

  return (
    <section id="news" className={s.section}>
      <div className={s.headerContainer}>
        <h3 className={s.headerTitle}>Novedades y Anuncios</h3>
        <p className={s.headerSubtitle}>Actualizaciones del programa MSC Rewards</p>
      </div>

      <div className={ns.controlsRow}>
        <div className={ns.sortWrapper}>
          <button onClick={() => setIsAsc(!isAsc)} className={ns.sortBtn}>
            {isAsc ? 'más próximos primero' : 'más lejanos primero'}
            <svg className={`w-4 h-4 transition-transform duration-500 ${isAsc ? 'rotate-180 text-msc-yellow' : 'text-msc-green'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="3">
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </div>

      <div className={ns.sectionGrid}>
        {displayedNews.map((item) => (
          <div key={item.id} className={maxPerRow === 3 ? ns.cardWrapper3 : ns.cardWrapper4}>
            <div className={ns.tagContainerLeft}><span className={ns.tag}>{formatDateLabel(item.starts_at, item.ends_at)}</span></div>
            <div className={ns.tagContainerRight}><span className={ns.tag}>{formatLocationLabel(item.location)}</span></div>
            <NewsCard item={item} userCities={userCities} />
          </div>
        ))}
      </div>

      {news.length > maxPerRow && (
        <div className={ns.expandWrapper}>
          <button onClick={toggleExpand} className={ns.expandBtn}>
            <div className={`${ns.expandIcon} ${isExpanded ? 'rotate-180 text-msc-red' : 'text-msc-green'}`}>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="4"><path d="M19 9l-7 7-7-7" /></svg>
            </div>
            <span className={ns.expandLabel}>{isExpanded ? 'Colapsar noticias' : `Ver todas (${news.length})`}</span>
          </button>
        </div>
      )}
    </section>
  );
};

export default News;